import { TextField, RadioGroup, FormControlLabel, Radio, Box, Typography } from "@mui/material";
import { Colors } from "../../Styles/Colors";

export function ReusableTextInput({ label, name, value, onChange, disabled, maxLength }) {
    return (
        <TextField
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            fullWidth
            size="small"
            autoComplete="off"
            disabled={disabled}
            inputProps={maxLength ? { maxLength } : {}}
        />
    );
}

export function ReusableRadioGroup({ name, value, disabled, options, onChange }) {
    return (
        <RadioGroup
            row
            value={value}
            onChange={(e) => onChange(name, e.target.value)}
        >
            {options.map((opt) => (
                <FormControlLabel
                    key={opt}
                    value={opt}
                    disabled={disabled}
                    control={<Radio />}
                    label={opt}
                />
            ))}
        </RadioGroup>
    );
}

export const FormRow = ({ label, children }) => (
    <Box
        sx={{
            display: "grid",
            gridTemplateColumns: "30% 70%",
            alignItems: "center",
            gap: "0.5vw",
            width: "100%"
        }}
    >
        <Typography sx={{ fontSize: "0.9vw", fontWeight: Colors.SecondaryText }}>
            {label}
        </Typography>

        {children}
    </Box>
);